module.exports = __webpack_public_path__ + "static/media/logo_MonkeyPOS.16d68efc.png";